import { jsPDF } from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import { CircularProgress, Grid, Icon } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import { gql, useLazyQuery } from "@apollo/client";
import EmpleadoLayout from "components/LayoutContainers/EmpleadoLayout";
import boxShadows from "assets/theme/base/boxShadows";
import EditableText from "components/EditableText";
import PdfHeader from "../components/pdfHeader";
import { formatMoneyPuntoDecimal } from "utils/formatters";
import { formatDate } from "utils/formatters";
import { Money2Text } from "utils/formatters";
import { nombreCompraDetalle, unidadCompraDetalle } from "utils/presentacionCompra";


const textosIniciales = [
  "----/--",
  "CONCURSO",
  "....",
  "....",
  "30 días",
  "....",
  "--/--/--",
  "--/--/--",
  "--/--/--",
  "--/--/--",
  "--/--/--",
  "--/--/--",
  "--/--/--",
  "....",
  "----/--",
  "UNIVERSIDAD PROVINCIAL DE OFICIOS \"EVA PERON\" ",
  "....-....-......",
  "0.00",
];

const SolicitudGastos = () => {
  const documentsRef = useRef(null);
  const { id } = useParams();
  const { lg } = boxShadows;

  const [textArray, setTextArray] = useState(textosIniciales);
  const [editable, setEditable] = useState(true);

  const [data, setData] = useState(null);
  const [getPedido, { loading }] = useLazyQuery(
    gql`
      query getPedido($id: ID) {
        pedidosCompra(filter: { id: $id }) {
          id
          tipoCompra
          numeroExpediente
          fechaSolicitud
          licitacionInicio
          licitacionFin
          objetoCompra
          domicilioEntrega
          justificacion
          responsable {
            nombre
            apellido
            telefono
            email
          }
          detalles{
            id
            numero
            nombreCompra
            unidadNombre
            unidadAbreviatura
            requierePack
            unidadPack
            materiaPrima{
              id
              nombre
              nombreCompra
              tipoUnidad {
                nombre
                multiplicador
              }
            }
            cantidad
            cantidadVerificada
            observacion
            precioEstimado
            nombreServicio
          }
          proveedores{
            documento
            razonSocial
            nombre
            apellido
            habilitado
            user{
              email
            }
          }
        }
      }
    `,
    {
      onCompleted: (data) => {
        if (!data?.pedidosCompra[0]) return;
        setData(data.pedidosCompra[0]);
      },
    }
  );

  useEffect(() => {
    if (id) {
      getPedido({ variables: { id } });
    }
  }, [id]);

  useEffect(() => {
    if (data) {
      const newTextArray = [...textArray];
      newTextArray[0] = data.id;
      newTextArray[1] = data.tipoCompra?.toUpperCase();
      newTextArray[2] = data.objetoCompra || "...";
      newTextArray[6] = formatDate(data.fechaSolicitud, "dd/MM/yyyy") || "--/--/--";
      newTextArray[8] = formatDate(data.licitacionInicio, "dd/MM/yyyy") || "--/--/--";
      newTextArray[9] = formatDate(data.licitacionFin, "dd/MM/yyyy") || "--/--/--";

      newTextArray[14] = data.id || "----/--";
     const total = data.detalles.reduce((acc, detalle) =>
             acc + (detalle.cantidadVerificada * detalle.precioEstimado), 0
           ) || 0;
     
           const formattedTotal = formatMoneyPuntoDecimal(total.toFixed(2));
           newTextArray[17] = "$ " + formattedTotal;


      setTextArray(newTextArray);
    }
  }, [data]);

  const handleGeneratePdf = async () => {
    setEditable(false);
    const document = documentsRef.current.childNodes[0];
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: "portrait",
      hotfixes: ["px_scaling"],
      compress: true,
    });

    await doc.html(document, {
      margin: [50, 0, 50, 0],
      callback(doc) {
        doc.save(`exd-pedidoNro-${data.id}-activación-proceso-contratación.pdf`);
      },
    });
    setEditable(true);
  };

  const handleTextChange = (e, index) => {
    const newTextArray = [...textArray];
    newTextArray[index] = e.target.innerText;
    setTextArray(newTextArray);
  };

  if (!data) return (
    <EmpleadoLayout>
      <SoftBox display="flex" justifyContent="center" alignItems="center" height="100vh" flexDirection="column" gap={3}>
        {loading ? (<>
          <CircularProgress size={40} color="primary" />
          <SoftTypography variant="h5">Cargando</SoftTypography>
        </>) : (<>
          <Icon fontSize="large">search_off</Icon>
          <SoftTypography variant="h5">No se encontró el pedido</SoftTypography>
        </>)}
      </SoftBox>
    </EmpleadoLayout>
  );

  const total = data.detalles.reduce((acc, detalle) => acc + (detalle.cantidad * detalle.precioEstimado), 0);
  const totalEnLetras = Money2Text(total);


  return (
    <EmpleadoLayout>
      <SoftBox
        p={2}
        display="flex"
        alignItems="center"
        flexDirection="column"
        minHeight="100vh"
        height="100%"
      >
        <div ref={documentsRef}>
          <SoftBox
            sx={{
              position: "relative",
              overflow: "hidden",
              width: "794px",
              backgroundColor: "#ffffff",
              boxShadow: lg,
              px: 6,
            }}
            pb={5}
          >
            {/* ACA VA TODO EL CODIGO */}
            <PdfHeader />

            <SoftBox display="flex" flexDirection="column" gap={2}>
              <Grid container border="1pt solid black" lineHeight={1}>
                <Grid item px={6} py={1} xs={12} borderBottom="1pt solid black" textAlign="center">
                  <SoftTypography variant="caption" fontWeight="bold">
                    SOLICITUD DE GASTOS Y ESPECIFICACIONES TÉCNICAS
                  </SoftTypography>
                </Grid>
                {/* <Grid
                  item
                  xs={4}
                  borderRight="1pt solid black"
                  backgroundColor="rgba(230, 230, 230)"
                  pl={1}
                >
                  <SoftTypography variant="caption">Objeto</SoftTypography>
                </Grid> */}
                {/* <Grid item xs={8} pl={1}>
                  <SoftTypography variant="caption">
                    <EditableText
                      tooltip="Objeto"
                      editable={editable}
                      content={textArray[2]}
                      handleOnBlur={(e) => handleTextChange(e, 2)}
                    />
                  </SoftTypography>
                </Grid> */}
              </Grid>

              <Grid
                container
                border="1pt solid black"
                sx={{
                  '& > *:not(:last-child)': { borderBottom: "1pt solid black" },
                  '& > *:nth-child(-n+2)': { backgroundColor: "rgba(230, 230, 230)" }
                }}
                lineHeight={1}
              >
                <Grid item xs={12} px={1}>
                  <SoftTypography variant="caption" fontWeight="bold">PRODUCTOS O SERVICIOS REQUERIDOS</SoftTypography>
                </Grid>

                <Grid item xs={12} container sx={{ '& > *:not(:last-child)': { borderRight: "1pt solid black" } }}>
                  <Grid item xs={0.5} px={1}>
                    <SoftTypography variant="caption">N° </SoftTypography>
                  </Grid>
                  <Grid item xs={1} px={1}>
                    <SoftTypography variant="caption">Código</SoftTypography>
                  </Grid>
                  <Grid item xs={7.5} px={1}>
                    <SoftTypography variant="caption">Descripción</SoftTypography>
                  </Grid>
                  <Grid item xs={1.5} px={1}>
                    <SoftTypography variant="caption">Cantidad</SoftTypography>
                  </Grid>
                  <Grid item xs={1.5} px={1}>
                    <SoftTypography variant="caption">Unidad</SoftTypography>
                  </Grid>
                  {/* <Grid item xs={1.5} px={1}>
                    <SoftTypography variant="caption">Precio Unitario</SoftTypography>
                  </Grid>
                  <Grid item xs={1.5} px={1}>
                    <SoftTypography variant="caption">Precio Total Referencia</SoftTypography>
                  </Grid> */}
                  {/* <Grid item xs={1.5} px={1}>
                    <SoftTypography variant="caption">Imagen </SoftTypography>
                  </Grid> */}
                </Grid>

                {data.detalles
                  .filter(detalle => detalle.cantidadVerificada > 0)
                  .map((detalle, index) => (
                  <Grid key={index} item xs={12} container sx={{ '& > *:not(:last-child)': { borderRight: "1pt solid black" } }}>
                    <Grid item xs={0.5} px={1}>
                      <SoftTypography variant="caption">{detalle.numero}</SoftTypography>
                    </Grid>
                    <Grid item xs={1} px={1}>
                      <SoftTypography variant="caption">{detalle.materiaPrima?.id || "0000"}</SoftTypography>
                    </Grid>
                    <Grid item xs={7.5} px={1}>
                      <SoftTypography variant="caption">{[nombreCompraDetalle(detalle), !detalle.requierePack && detalle.observacion].filter(Boolean).join(" | ")}</SoftTypography>
                    </Grid>
                    <Grid item xs={1.5} px={1}>
                      <SoftTypography variant="caption">{detalle.cantidadVerificada || "-"}</SoftTypography>
                    </Grid>
                    <Grid item xs={1.5} px={1}>
                      <SoftTypography variant="caption">{unidadCompraDetalle(detalle)}</SoftTypography>
                    </Grid>
                    {/* <Grid item xs={1.5} px={1}>
                      <SoftTypography variant="caption">$ {formatMoneyPunto(detalle.precioEstimado || 0)}</SoftTypography>
                    </Grid>
                    <Grid item xs={1.5} px={1}>
                      <SoftTypography variant="caption">$ {formatMoneyPunto((detalle.cantidad * detalle.precioEstimado) || 0)}</SoftTypography>
                    </Grid> */}
                    {/* <Grid item xs={1.5} px={1} py={0.5} alignItems={"center"} display="flex" justifyContent="center">
                      {console.log(detalle.materiaPrima?.imagen)}
                      {detalle.materiaPrima?.imagen ? (
                        <img
                          src={resolveStoredFileUrl(detalle.materiaPrima.imagen)}
                          style={{ width: "70px", height: "70px", objectFit: "cover" }}
                        />
                      ) : (
                        <SoftTypography variant="caption">-</SoftTypography>
                      )}
                    </Grid> */}
                  </Grid>

                ))}
              </Grid>
              <Grid
                container
                border="1pt solid black"
                sx={{
                  '& > *:not(:last-child)': { borderBottom: "1pt solid black" },
                  '& > *:nth-child(-n+2)': { backgroundColor: "rgba(230, 230, 230)" }
                }}
                lineHeight={1}
              >
                <Grid item xs={12} container sx={{ '& > *:not(:last-child)': { borderRight: "1pt solid black" } }}>
                  <Grid item xs={10.5} px={1}>
                    <SoftTypography variant="caption" fontWeight="bold">
                      Consultas Técnicas: {data.responsable?.nombre} {data.responsable?.apellido} - {data.responsable?.email}
                    </SoftTypography>
                  </Grid>
                  {/* <Grid item xs={1.5} px={1}>
                    <SoftTypography variant="caption">$ {formatMoneyPunto(data.detalles.reduce((acc, detalle) => acc + (detalle.cantidad * detalle.precioEstimado), 0) || 0)}</SoftTypography>
                  </Grid> */}
                </Grid>
                <Grid item xs={12} px={1}>
                  <SoftTypography variant="caption" fontWeight="bold">JUSTIFICACION:{data.justificacion}.-</SoftTypography>
                </Grid>
                <Grid item xs={12} px={1}>
                  <SoftTypography variant="caption">El pedido debe see entregado en: {data.domicilioEntrega}.</SoftTypography>
                </Grid>
              </Grid>

            </SoftBox>
          </SoftBox>
        </div>
        <SoftBox
          variant="contained"
          bgColor="white"
          p={2}
          style={{
            position: "fixed",
            bottom: "1.5rem",
            right: "1.5rem",
            zIndex: 1000,
            boxShadow:
              "inset 0rem 0rem 0.0625rem 0.0625rem rgb(255 255 255 / 90%), 0rem 1.25rem 1.6875rem 0rem rgb(0 0 0 / 5%)",
            borderRadius: "16px",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: `saturate(200%) blur(${pxToRem(30)})`,
          }}
        >
          <Grid container spacing={2} justifyContent="flex-end" id="button">
            <Grid item>
              <SoftButton variant="gradient" color="error" onClick={handleGeneratePdf}>
                <Icon fontWeight="bold">picture_as_pdf</Icon>
                &nbsp;&nbsp;Descargar PDF
              </SoftButton>
            </Grid>
          </Grid>
        </SoftBox>
      </SoftBox>
    </EmpleadoLayout>
  );
};

export default SolicitudGastos;
